import React from 'react';
import IframePage from "../iframe-page/iframe-page";
import config from "../../config";

const AnalyticsReturnsPage: React.FC = () => {
    return (
        <IframePage url={`${config.apiUrl}/dashboard/analytics/returns`} />
    );
}

export default AnalyticsReturnsPage;